import styled from 'styled-components';
import { infoStore, ParticipationStatus } from '../../../store/infoStore';
import { useState } from 'react';
import { useDateHook } from '../../../hook/useDateHook';
import { End } from './End';
import { ProgressTicket } from './ProgressTicket';
import {
  EventTabType,
  MAIN_TAB_STATUS,
  PROGRESS_TAB_STATUS,
  SUB_TAB_STATUS,
} from '../../../types/type';
import { mobileQuery } from '../../../utils';
import { WaringModal } from '../../modal/WaringModal';
import { tabStore } from '../../../store/tabStore';
import { modalStore } from '../../../store/modalStore';

export const ProgressInfo = () => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const { mainInfo, sideInfo } = infoStore();
  const { isOverPrivacyDate, isSatelliteEnd } = useDateHook();
  const { setSubTab, getCurrentSubTab } = tabStore();
  const { showIsVisibleEndDate, showPrivacyModal } = modalStore();

  // 현재 활성화된 서브탭
  const activeSubTab = getCurrentSubTab(MAIN_TAB_STATUS.PROGRESS);

  // 이벤트 타입 확인 (메인/사이드)
  const isMainTab = activeSubTab === SUB_TAB_STATUS.PROGRESS_MAIN;
  const eventTab = isMainTab ? EventTabType.MAIN : EventTabType.SIDE;
  const info = eventTab === EventTabType.MAIN ? mainInfo : sideInfo;
  const isActiveTicket = info.status === ParticipationStatus.CHECK_ELIGIBLE;
  const isMain = eventTab === EventTabType.MAIN;

  const notAgreed =
    mainInfo.status === ParticipationStatus.NOT_AGREED ||
    sideInfo.status === ParticipationStatus.NOT_AGREED;

  // 진행 상태에 따른 컨텐츠 렌더링
  const renderProgressContent = () => {
    // 티켓 상태 체크
    if (info.ticketCnt === 0) {
      if (isSatelliteEnd()) {
        // 새틀라이트 종료됨
        return <End isMain={isMain} />;
      } else {
        // 새틀라이트 진행 중
        return <End isMain={isMain} />;
      }
    }

    // 새틀라이트 종료됨
    if (isSatelliteEnd()) {
      return <End isMain={isMain} />;
    }

    // 티켓 비활성화 상태
    return (
      <ProgressTicket
        showWaringModal={() => setShowWarningModal(true)}
        isMain={isMain}
        ticketCnt={info.ticketCnt || 0}
        isActiveTicket={isActiveTicket}
      />
    );
  };

  return (
    <>
      <TabContainer>
        <TabButton
          $type={SUB_TAB_STATUS.PROGRESS_MAIN}
          $isActive={isMain}
          onClick={() => {
            if (notAgreed) {
              // 동의 기간이 지난 경우
              if (!isOverPrivacyDate) {
                showPrivacyModal();
              } else {
                showIsVisibleEndDate();
              }
            }

            setSubTab(MAIN_TAB_STATUS.PROGRESS, PROGRESS_TAB_STATUS.MAIN);
          }}
        >
          <TabText $isActive={isMain}>메인 이벤트</TabText>
        </TabButton>

        <TabButton
          $type={SUB_TAB_STATUS.PROGRESS_SIDE}
          $isActive={!isMain}
          onClick={() => {
            if (notAgreed) {
              // 동의 기간이 지난 경우
              if (!isOverPrivacyDate) {
                showPrivacyModal();
              } else {
                showIsVisibleEndDate();
              }
            }

            setSubTab(MAIN_TAB_STATUS.PROGRESS, PROGRESS_TAB_STATUS.SIDE);
          }}
        >
          <TabText $isActive={!isMain}>사이드 이벤트</TabText>
        </TabButton>
      </TabContainer>

      {renderProgressContent()}

      <WaringModal visible={showWarningModal} close={() => setShowWarningModal(false)} />
    </>
  );
};

// 스타일 컴포넌트
const TabContainer = styled.div`
  display: flex;
  max-width: 600px;
  margin: 0 auto;
  padding-top: 40px;

  ${mobileQuery} {
    padding-left: 13px;
    padding-right: 13px;
    padding-top: 10px;
  }
`;

const TabButton = styled.button<{ $isActive: boolean; $type: string }>`
  display: flex;
  flex: 1;
  height: 42px;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  background: ${(props) =>
    props.$isActive
      ? props.$isActive && props.$type === 'progress-main'
        ? 'linear-gradient(95deg, #B3004E 20.33%, #87083F 93.59%)'
        : 'linear-gradient(102deg, #0059FF -6.05%, #1140A7 58.73%)'
      : '#434343'};
  border: 2px solid
    ${(props) =>
      props.$isActive
        ? props.$isActive && props.$type === 'progress-main'
          ? '#C30B5F'
          : '#1859C7'
        : '#434343'};

  &:first-child {
    margin-right: 6px;
  }

  ${mobileQuery} {
    height: 31px;
  }
`;

const TabText = styled.h3<{ $isActive: boolean }>`
  font-weight: ${(props) => (props.$isActive ? '600' : '500')};
  font-size: 20px;
  line-height: 34px;
  color: ${(props) =>
    props.$isActive ? 'rgba(255, 255, 255, 0.80)' : 'rgba(255, 255, 255, 0.50)'};

  ${mobileQuery} {
    font-size: 14px;
    line-height: 17px;
  }
`;
